import { FC } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100%',
        maxHeight: 'inherit',
        overflowX: 'hidden',
        overflowY: 'auto',
        scrollbarGutter: 'stable',
        scrollbarColor: `${theme.palette.primary.main} #e4e4e4`,
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
            width: (props: any) => (props?.scrollbarWidth ? `${props.scrollbarWidth}px` : '6px'),
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: (props: any) =>
                props?.scrollbarTrackBorderRadius ? `${props.scrollbarTrackBorderRadius}px` : '0px',
            backgroundColor: (props: any) =>
                props?.scrollbarTrackBackgroundColor ? `${props.scrollbarTrackBackgroundColor}` : '#e4e4e4',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: (props: any) =>
                props?.scrollbarThumbBorderRadius ? `${props.scrollbarThumbBorderRadius}px` : '0px',
            background: (props: any) =>
                props?.scrollbarThumbBackgroundColor
                    ? `${props.scrollbarThumbBackgroundColor}`
                    : theme.palette.primary.main,
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: theme.palette.primary.dark,
        },
    },
}))

type ScrollbarProps = {
    scrollbarWidth?: number
    scrollbarTrackBorderRadius?: number
    scrollbarThumbBorderRadius?: number
    scrollbarTrackBackgroundColor?: string | 'white'
    scrollbarThumbBackgroundColor?: string | 'white'
    style?: any
    onScroll?: (event: any) => void
}
const Scrollbar: FC<ScrollbarProps> = (props) => {
    const styled = {
        scrollbarWidth: props.scrollbarWidth,
        scrollbarTrackBorderRadius: props.scrollbarTrackBorderRadius,
        scrollbarThumbBorderRadius: props.scrollbarThumbBorderRadius,
        scrollbarTrackBackgroundColor: props.scrollbarTrackBackgroundColor,
        scrollbarThumbBackgroundColor: props.scrollbarThumbBackgroundColor,
    }
    const classes = useStyles(styled)

    return (
        <div
            className={classes.root}
            style={{ ...props.style }}
            onScroll={(event) => {
                props.onScroll?.(event)
            }}
        >
            {props.children}
        </div>
    )
}

export default Scrollbar
